import { Text, VStack } from "@chakra-ui/react";
import { formatDate } from "@syla/shared/helpers/formatting";
import { getSubscriptionState } from "@syla/shared/types/helpers/subscriptions";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import { format } from "date-fns";
import { enAU } from "date-fns/locale";
import React from "react";
import { TooltipWrapper } from "../../components/atoms/TooltipWrapper";
import { PlanStatusTag } from "../accountSettings/subscription/PlanStatusTag";

interface RenewalDateProps {
  subscription: SubscriptionWithPlansAndAccess<string> | undefined;
}

export const RenewalDateCell = ({ subscription }: RenewalDateProps) => {
  if (!subscription) {
    return (
      <VStack alignItems="flex-start">
        <Text>N/A</Text>
      </VStack>
    );
  }

  const subscriptionState = getSubscriptionState(subscription);

  const formattedDate = format(subscriptionState.renewsOn, "P", {
    locale: enAU,
  });

  if (
    subscriptionState?.valid &&
    !subscriptionState.cancelled &&
    subscriptionState.renewsOn
  ) {
    const tooltip = `Renews on ${formatDate(subscriptionState.renewsOn)}`;

    return (
      <VStack alignItems="flex-start">
        <TooltipWrapper tooltip={tooltip}>
          <Text>{formattedDate}</Text>
        </TooltipWrapper>
        <PlanStatusTag status={subscriptionState.planStatus} />
      </VStack>
    );
  }

  if (subscriptionState?.cancelled && subscriptionState.lapsesOn) {
    const tooltip = `Expires on ${formatDate(subscriptionState.renewsOn)}`;

    return (
      <VStack alignItems="flex-start">
        <TooltipWrapper tooltip={tooltip}>
          <Text>Expires {formattedDate}</Text>
        </TooltipWrapper>
        <PlanStatusTag status={subscriptionState.planStatus} />
      </VStack>
    );
  }

  if (subscriptionState?.lapsed) {
    return (
      <VStack alignItems="flex-start">
        <PlanStatusTag status={subscriptionState.planStatus} />
      </VStack>
    );
  }

  const isExpiredNeedingAction =
    subscriptionState &&
    !subscriptionState.valid &&
    !subscriptionState.lapsed &&
    !subscriptionState.cancelled;

  if (isExpiredNeedingAction && subscriptionState.lapsesOn) {
    return (
      <VStack alignItems="flex-start">
        <PlanStatusTag status={subscriptionState.planStatus} />
      </VStack>
    );
  }

  // fallback
  return (
    <VStack alignItems="flex-start">
      <Text>—</Text>
    </VStack>
  );
};
